import { render } from "./CodePage.vue?vue&type=template&id=10332e40&scoped=true"
import script from "./CodePage.vue?vue&type=script&lang=js"
export * from "./CodePage.vue?vue&type=script&lang=js"

import "./CodePage.vue?vue&type=style&index=0&id=10332e40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10332e40"]])

export default __exports__